const APP_CONFIG = {
  REACT_APP_API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || "https://api.propmanage.space/",
  REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
};

export default APP_CONFIG;
